import { useOptionAddInfContext } from "./context";

export const useSetBaseInf = () => {
  const { koValuesRef, enValuesRef, jaValuesRef } = useOptionAddInfContext();
  const setBasetInf = (langCd: string, formData: any) => {
    if (langCd === "ko") {
      koValuesRef.current = {
        ...(koValuesRef.current || {}),
        ...formData,
      };
    }
    if (langCd === "en") {
      enValuesRef.current = {
        ...(enValuesRef.current || {}),
        ...formData,
      };
    }
    if (langCd === "ja") {
      jaValuesRef.current = {
        ...(jaValuesRef.current || {}),
        ...formData,
      };
    }
  };
  return {
    setBasetInf,
  };
};

export const useEditedLang = () => {
  const { koValuesRef, enValuesRef, jaValuesRef } = useOptionAddInfContext();
  const editedLang = () => {
    let lang = [] as Array<string>;
    const koValue = Object.values(koValuesRef.current || {}).some(
      (value) => value !== "" && value !== null && value !== undefined
    );
    const enValue = Object.values(enValuesRef.current || {}).some(
      (value) => value !== "" && value !== null && value !== undefined
    );
    const jaValue = Object.values(jaValuesRef.current || {}).some(
      (value) => value !== "" && value !== null && value !== undefined
    );

    if (koValue) {
      lang.push("ko");
    }
    if (enValue) {
      lang.push("en");
    }
    if (jaValue) {
      lang.push("ja");
    }

    return lang;
  };

  return {
    editedLang,
  };
};
